import React from 'react'
import { Partytown } from '@builder.io/partytown/react'
import config from 'config'
import { constants } from 'helpers'
import { useAb } from 'hooks'


const ASSETS_PATH = !config.assetsPath.startsWith('/') ? '/' : config.assetsPath

const PARTYTOWN_LIB = `${ASSETS_PATH}~partytown/`
const PARTYTOWN_LOAD_ON_MAIN_THREAD = [
  'https://static.ads-twitter.com/uwt.js',
  'https://www.paypal.com/sdk/js?components=shopping&client-id=AZYuyvRcXOyRrMlqIeC6VOs7brfojpXFsELoXN-sS35X9_b3Lia19KyGlSRoCsMaZAY15bJgLF7Uwxq7',
]
const PARTYTOWN_FORWARD = [
  'dataLayer.push',
  'Iterate',
  'mixpanel.people.set_once',
  'mixpanel.people.set',
  'mixpanel.register',
  'mixpanel.registerAbTestProps',
  'mixpanel.reset',
  'mixpanel.setupUser',
  'mixpanel.syncSuperPropertiesCookieInternal',
  'mixpanel.track',
  'mixpanel.unregister',
  'mixpanel.unregisterAbTestProps',
  'snowplow',
]
const PARTYTOWN_MAIN_WINDOW_ACCESSORS = [
  'marketingActions.applyPixel',
  'setMixpanelCookie',
  'shoppingDDL.push',
  'twq',
]

const resolveUrl = (url) => {
  const { hostname } = url

  const shouldProxy = [
    'adsrvr.org',
    'apis.google.com',
    'attn.tv',
    'cnstrc.com',
    'cpi.scentbird.com',
    'crazyegg.com',
    'doubleclick.net',
    'facebook.net',
    'getrockerbox.com',
    'google-analytics.com',
    'googleadservices.com',
    'googletagmanager.com',
    'hotjar.com',
    'impactradius-event.com',
    'liadm.com',
    'mysingleromance.com',
    'newrelic.com',
    'paypalobjects.com',
    'solvvy.com',
  ].some((proxiedDomain) => {
    return hostname.includes(proxiedDomain)
  })

  if (shouldProxy) {
    const proxyUrl = new URL(`${self.origin}/proxy`)

    proxyUrl.searchParams.append('url', url.href)

    const clientId = url.searchParams.get('client-id')

    if (clientId) {
      proxyUrl.searchParams.append('client-id', clientId)
    }

    return proxyUrl
  }
}

const PartytownSetup: React.FunctionComponent = () => {
  const isPartytownFeatureEnabled = useAb(constants.abTests.partytown) === 'b'

  if (!isPartytownFeatureEnabled) {
    return null
  }

  return (
    <Partytown
      debug={config.runEnv !== 'prod'}
      forward={PARTYTOWN_FORWARD}
      lib={PARTYTOWN_LIB}
      loadScriptsOnMainThread={PARTYTOWN_LOAD_ON_MAIN_THREAD}
      logScriptExecution
      mainWindowAccessors={PARTYTOWN_MAIN_WINDOW_ACCESSORS}
      resolveUrl={resolveUrl}
    />
  )
}

export default React.memo(PartytownSetup)
